import { ROUTES } from "../components/shared/constant";

/**
 * Opens an instance with a full page load (not navigate): the only thing that
 * clears RTK Query's instance-scoped cache on an instance change. From the
 * sign-in callback it lands on Home; anywhere else it keeps the page.
 */
export function reloadIntoInstance(instanceId: string): void {
  const url = window.location.href;
  const arr = url.split("/");
  if (window.location.pathname === ROUTES.CALLBACK) {
    window.location.href = arr[0] + "//" + arr[2] + ROUTES.HOME + "?instanceid=" + instanceId;
  } else {
    window.location.href =
      arr[0] + "//" + arr[2] + window.location.pathname + "?instanceid=" + instanceId;
  }
}
